import { useCampaignsPlatformEditAction } from './useCampaignsPlatformEditAction';
export function useCampaignsPlatformEditActionMenuItem({
  objectType,
  assetId,
  crmIdProperty = 'hs_object_id'
}) {
  const {
    isDisabled,
    onCampaignEdit,
    editActionText
  } = useCampaignsPlatformEditAction({
    objectType,
    assetId,
    crmIdProperty
  });
  if (isDisabled) {
    return {
      onCampaignEdit: () => {},
      actionMenuItems: []
    };
  }
  return {
    onCampaignEdit,
    actionMenuItems: [{
      text: editActionText,
      value: 'campaignsPlaformEditAction'
    }]
  };
}